define('datakit/hal/hal.collection',['require','exports','module','../collection','underscore'],function(require, exports, module) {
  var Collection = require('../collection');
  var _          = require('underscore');

  var HalCollection = Collection.extend({

    initialize: function(models, options) {
      Collection.prototype.initialize.apply(this, arguments);
      options = options || {};
      if (options.rel) {
        this.rel = options.rel;
      }
    },

    findEmbeddedRel: function(embedded) {
      return this.rel || _.keys(embedded)[0];
    },

    parse: function(resp) {
      var embedded = resp._embedded || {},
          rel      = this.findEmbeddedRel(embedded);
      return embedded[rel] || [];
    }

  });

  module.exports = HalCollection;
});

